import {XCircleIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'
import {Link} from '@github-ui/react-router'
import {ForYouItem} from '../shared/ForYouItem'
import {ForYouLeadingIcon} from '../shared/ForYouLeadingIcon'
import {useFailedChecksData, type FailedRequiredCheck} from './use-failed-checks-data'
import {usePullRequestAnalytics} from '../../../../hooks/use-pull-request-analytics'
import {isMiniMergeboxEnabled} from '../../mergebox/is-mini-mergebox-enabled'

// Surfaces each failed required status check as its own item. The parent
// ForYouItemBoundary decides which subsection (and thus which viewer) sees it via
// its `audience` prop, so this component stays audience-agnostic.
export function FailingChecks() {
  const failedChecks = useFailedChecksData()

  if (!failedChecks || failedChecks.length === 0) {
    return null
  }

  if (isMiniMergeboxEnabled()) {
    return null
  }

  return (
    <>
      {failedChecks.map(check => (
        <FailedCheckItem key={check.key} check={check} />
      ))}
    </>
  )
}

function FailedCheckItem({check}: {check: FailedRequiredCheck}) {
  const {sendPullRequestAnalyticsEvent} = usePullRequestAnalytics()
  return (
    <ForYouItem
      leadingVisual={<ForYouLeadingIcon icon={XCircleIcon} variant="danger" />}
      title={check.name}
      itemName="failed-check"
      description={check.detailText}
      actionSlot={
        check.targetUrl ? (
          <Button
            as={Link}
            to={check.targetUrl}
            size="small"
            aria-label={`View details for ${check.name}`}
            onClick={() =>
              sendPullRequestAnalyticsEvent('overview.for_you_item_action', 'OVERVIEW_FOR_YOU_ITEM', {
                item_name: 'failed-check',
                action_name: 'view_details',
              })
            }
          >
            View details
          </Button>
        ) : undefined
      }
    />
  )
}
